import { useComputedColorScheme, Group } from '@mantine/core';

// @ts-ignore
import logoLight from '../assets/watchly-logo.png';
import logoDark from '../assets/watchly-logo-dark.png';

type Props = {
    size?: string;
    forceDark?: boolean;
    noMargin?: boolean;
};

const Logo = (props: Props) => {
    const scheme = useComputedColorScheme();
    const logo = (props.forceDark || scheme === 'dark') ? logoDark : logoLight;

    const logoWidth =
        props.size === 'sm' ? '60px' : props.size === 'lg' ? '120px' : props.size === 'xl' ? '240px' : '90px';

    return (
        <Group gap={0}>
            <img src={logo} style={{ width: logoWidth, margin: props.noMargin ? 0 : '16px' }} />
        </Group>
    );
};

export default Logo;
